module Meevo.Plugins.SystemToolbox {
    export class SelectMerchantAccountModalController {
        selectedMerchantAccountId: string;
        meevoPayMerchantAccounts: Meevo.Model.MerchantAccount[];

        static $inject = [
            'meevo.components.modal.ModalService',
            'meevoPayMerchantAccounts'
        ];

        constructor(
            private modalService: Meevo.Components.Modal.IModalService,
            meevoPayMerchantAccounts: Meevo.Model.MerchantAccount[]
        ) {
            this.meevoPayMerchantAccounts = meevoPayMerchantAccounts;
        }

        private isValid(): boolean {
            return !!this.selectedMerchantAccountId;
        }

        continue() {
            if (!this.isValid()) {
                return;
            }

            this.close(this.selectedMerchantAccountId);
        }

        close(response) {
            this.modalService.hideWithResponse(response);
        }

        cancel() {
            this.close(null);
        }
    }

    angular.module("meevo.plugins.systemToolbox")
        .controller("meevo.plugins.systemToolbox.SelectMerchantAccountModalController", SelectMerchantAccountModalController);
}
